import React, { lazy, Suspense } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

const Home = lazy(() => import('./home/view/provider'));
const Simulator = lazy(() => import('./simulator/view/provider'));
const CallToAction = lazy(() => import('./calltoaction/view/provider'));
const Forms = lazy(() => import('./form/view/provider'));

export const history = createBrowserHistory({ basename: window.CONTEXT_PATH });
export default class Navigator extends React.Component {
  constructor() {
    super();

    if (window.performance) {
      if (performance.navigation.type === 1) {
        history.push('/');
      }
    }
  }

  render() {
    console.log('Home', Home);
    return (
      <Router basename="/" history={history}>
        <Suspense fallback={<div>Chargement...</div>}>
          <Switch>
            <Route exact path="/" component={CallToAction} />
            <Route path="/home" component={Home} />
            <Route path="/simulator" component={Simulator} />
            <Route path="/calltoaction" component={CallToAction} />
            <Route path="/forms" component={Forms} />
          </Switch>
        </Suspense>
      </Router>
    );
  }
}
